import moment from "moment"
import React, { FunctionComponent } from "react"

interface TimeStampProps {
    value: string | undefined //TODO fix gql generated types
    format?: string
}

export const TimeStamp: FunctionComponent<TimeStampProps> = ({
    value,
    format = "YYYY-MM-DD HH:mm"
}) => {
    const timeStamp = moment.utc(value).format(format)
    return <>{timeStamp}</>
}
